module.exports = __webpack_public_path__ + "static/media/icon-instagram.7b1e7e84.svg";